import styles from "./Main.module.scss";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import { useTranslation } from "react-i18next";

const Main = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.liveCameras}>
      <SectionTitle text={t("Live camera view of the cultivation")} />
      <div className={styles.liveCameras__iframe}>
        <div className={styles.liveCameras__player}>
          <iframe
            src="https://deutsche-anbaugesellschaft.de/live/kamera.html"
            title="Livestream"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default Main;


